exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-wrapper[data-v-0130dcf0]{position:relative}.tooltip[data-v-0130dcf0]{font-size:13px;position:absolute;z-index:0;background:#213a55;padding:5px 12px;color:#f0f7fd;letter-spacing:.5px;-webkit-box-shadow:1px 3px 5px rgba(38,107,181,.15),-1px 3px 6px rgba(60,93,125,.14);box-shadow:1px 3px 5px rgba(38,107,181,.15),-1px 3px 6px rgba(60,93,125,.14);bottom:30px;-webkit-transform:translateY(0);transform:translateY(0);-webkit-transition:.2s;transition:.2s;text-transform:none;opacity:0}.tooltip.visible[data-v-0130dcf0]{-webkit-transform:translateY(100%);transform:translateY(100%);opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0130dcf0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/layout/Tooltip.vue
// module id = LVGU
// module chunks = 0 1